import React, {useCallback, useEffect, useRef, useState} from 'react'
import Axios from 'axios'
import {useParams} from 'react-router-dom'
import {Row, Col, Container} from 'reactstrap'
import ReactHtmlParser from 'react-html-parser'
import ImageGallery from 'react-image-gallery'


import {API_URL} from '../../ApiUrl.js'
import styles from './SingleEvent.module.css'

function SingleEvent() {
  let {eventId} = useParams()
  const [event, setEvent] = useState({})
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const galleryRef = useRef(null)

  const handleImageClick = () => {
    if (galleryRef.current) {
      galleryRef.current.slideNext()
    }
  }

  /* Only keep slots that have a real photo URL */
  const images = [
    event.photoURL,
    event.photoEventOne,
    event.photoEventTwo,
    event.photoEventThree,
    event.photoEventFour,
  ]
    .filter(url => url && url !== 'undefined' && url !== 'null')
    .map(url => ({original: url}))

  const getEvents = useCallback(async () => {
    try {
      setLoading(true)
      const res = await Axios.get(`${API_URL}/api/event`)
      const eventData = res.data.find((item) => item.id === eventId)
      setEvent(eventData)
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [eventId])

  useEffect(() => {
    getEvents()
  }, [getEvents])

  return (
    <div className={styles.eventSinglePage}>
      {/* Title */}
      <h4 className={`${styles.title} text-center`}>{event.title}</h4>

      {/* Main layout */}
      <Container fluid className="flex-grow-1 d-flex flex-column px-0 overflow-hidden">
        <Row className="flex-grow-1 no-gutters h-100">

          {/* Left / top: carousel */}
          <Col lg="7" xs="12" className="h-100 d-flex align-items-center justify-content-center">
            <div className={styles.carousselEvent}>
              <ImageGallery
                ref={galleryRef}
                items={images}
                showThumbnails={false}
                showPlayButton={false}
                showFullscreenButton={false}
                showBullets={false}
                showNav={true}
                infinite={true}
                onClick={handleImageClick}
              />
            </div>
          </Col>

          {/* Right / bottom: text */}
          <Col lg="5" xs="12" className="h-100 d-flex flex-column justify-content-center px-4 px-lg-5">
            <div className={styles.textContent}>
              {ReactHtmlParser(event.content)}
            </div>
          </Col>

        </Row>
      </Container>
    </div>
  )
}

export default SingleEvent
